// Editar textos, metricas y links de la landing desde este archivo.
export const rsdContent = {
  links: {
    mediaKit: "https://ruteandosindestino.com/mediakit",
    collaboration: "mailto:ruteandosindestino.dm@gmail.com?subject=Colaboracion%20Ruteando%20Sin%20Destino",
    instagram: "https://www.instagram.com/ruteandosindestino/",
    facebook: "https://www.facebook.com/share/1CrxXmqNcb/?mibextid=wwXIfr",
    youtube: "https://www.youtube.com/@ruteandosindestino",
    tiktok: "https://www.tiktok.com/@ruteando.sin.destino",
    whatsapp: "https://wa.me/59892042015",
    whatsappLabel: "+598 92 042 015",
    email: "ruteandosindestino.dm@gmail.com",
    site: "https://ruteandosindestino.net/",
  },
  metrics: [
    { label: "Nuestra comunidad", value: "116.8k", icon: "community" },
    { label: "Visualizaciones mensuales", value: "1.5M", icon: "views" },
    { label: "Países recorridos", value: "6", icon: "countries" },
  ],
  collaborationWays: [
    {
      icon: "ruta",
      title: "Experiencias en ruta",
      text: "Mostramos hospedajes, destinos, actividades o lugares desde nuestra propia vivencia, con una mirada cercana y real.",
    },
    {
      icon: "productos",
      title: "Productos que usamos viajando",
      text: "Integramos productos que tengan sentido en la vida en motorhome, la ruta, el camping, la cocina, el descanso o la organización diaria.",
    },
    {
      icon: "gastronomia",
      title: "Gastronomia y lugares locales",
      text: "Compartimos restaurantes, cafeterías, comidas típicas o productos gastronómicos como parte natural del recorrido.",
    },
    {
      icon: "contenido",
      title: "Contenido para tu marca",
      text: "Creamos fotos, videos cortos o piezas simples que la marca puede usar en sus redes, anuncios o comunicación digital.",
    },
  ],
  brandFitLead:
    "Sumamos marcas que tienen sentido dentro de nuestra ruta: lugares donde paramos, experiencias que vivimos, productos que usamos y sabores que descubrimos en el camino.",
  brandCards: [
    {
      title: "Hospedajes",
      text: "Cabañas, hoteles y posadas que se viven mejor en ruta.",
      image: "hospedajes",
    },
    {
      title: "Campings y glampings",
      text: "Spots para acampar y dormir bajo las estrellas.",
      image: "campings",
    },
    {
      title: "Experiencias turísticas",
      text: "Excursiones y actividades que mostramos en movimiento.",
      image: "experiencias",
    },
    {
      title: "Marcas outdoor",
      text: "Equipo y gear que ponemos a prueba en el camino.",
      image: "outdoor",
    },
    {
      title: "Productos para viajeros",
      text: "Objetos que hacen mejor la vida sobre ruedas.",
      image: "productos",
    },
    {
      title: "Gastronomía local",
      text: "Cocinas, cafés y sabores de cada destino.",
      image: "gastronomia",
    },
    {
      title: "Destinos y agencias de turismo",
      text: "Lugares y rutas que vale la pena recorrer.",
      image: "destinos",
    },
  ],
  // PORTFOLIO: colaboraciones reales publicadas en Instagram y TikTok.
  // - thumb: id del video propio en el bucket S3 (el lightbox pide /api/video?id=<thumb>).
  // - href: link original para "ver en la red" si el usuario prefiere salir del sitio.
  // - image: sticker de marca para la miniatura del carrusel (se puede reemplazar por captura real).
  // - type: "Reel" | "Video" (define el icono/etiqueta del carrusel).
  // - platform: "instagram" | "tiktok" (define el logo del lightbox).
  // - embedUrl: opcional; reproduce el reel desde Instagram cuando no hay copia en S3.
  portfolio: [
    {
      brand: "Airalo | @airalo",
      type: "Reel",
      platform: "instagram",
      image: "hospedajes",
      thumb: "ig-01",
      caption: "",
      href: "https://www.instagram.com/reel/DZ-9xrqzHBQ/",
    },
    {
      brand: "Caracol Iguazú | Cataratas",
      type: "Reel",
      platform: "instagram",
      image: "destinos",
      thumb: "ig-02",
      caption: "",
      href: "https://www.instagram.com/ruteandosindestino/reel/DZGM85uyS_o/",
    },
    {
      brand: "La Toscana Trattoria - Puerto Iguazú",
      type: "Reel",
      platform: "instagram",
      image: "experiencias",
      thumb: "ig-03",
      caption: "",
      href: "https://www.instagram.com/ruteandosindestino/reel/DZDtP1gygYK/",
    },
    {
      brand: "Lavadora Motorhome - @foxtrailer",
      type: "Reel",
      platform: "instagram",
      image: "gastronomia",
      thumb: "ig-04",
      caption: "",
      href: "https://www.instagram.com/reel/DXw_zqbzDyL/",
    },
    {
      brand: "Caverna do Diabo | Brasil",
      type: "Reel",
      platform: "instagram",
      image: "campings",
      thumb: "ig-05",
      caption: "",
      href: "https://www.instagram.com/reel/DWSc8UBjCV-/",
    },
    {
      brand: "Lavanderías BR | @lavanderia60minutos",
      type: "Reel",
      platform: "instagram",
      image: "outdoor",
      thumb: "ig-06",
      caption: "",
      href: "https://www.instagram.com/reel/DWCNeRFkdVn/",
    },
    {
      brand: "Airbnb | @maremontanha_itamambuca",
      type: "Reel",
      platform: "instagram",
      image: "productos",
      thumb: "ig-07",
      caption: "",
      href: "https://www.instagram.com/reel/DVuD-oOEujM/",
    },
    {
      brand: "Turismo Cambará do Sul | @canionsgerais",
      type: "Reel",
      platform: "instagram",
      image: "hospedajes",
      thumb: "ig-08",
      caption: "",
      href: "https://www.instagram.com/reel/DSaOlQYjgnm/",
    },
    {
      brand: "Cabaña Porangatu | @cabanaporangatu",
      type: "Reel",
      platform: "instagram",
      image: "hospedajes",
      thumb: "ig-09",
      caption: "",
      href: "https://www.instagram.com/p/DcZdzE3TJ2H/",
      embedUrl: "https://www.instagram.com/reel/DcZdzE3TJ2H/embed/",
    },
    {
      brand: "Cabana do Park | @cabanadopark",
      type: "Reel",
      platform: "instagram",
      image: "hospedajes",
      thumb: "ig-10",
      caption: "",
      href: "https://www.instagram.com/p/Db9KhTbz8Q8/",
      embedUrl: "https://www.instagram.com/reel/Db9KhTbz8Q8/embed/",
    },
    {
      brand: "Mendoza Turismo Aventura | @parquedelaaventura",
      type: "Video",
      platform: "tiktok",
      image: "destinos",
      thumb: "tt-01",
      caption: "",
      href: "https://www.tiktok.com/@ruteando.sin.destino/video/7488849449603697925",
    },
    {
      brand: "Paulette & Plantine | Café de especialidad | @paulette.plantine",
      type: "Video",
      platform: "tiktok",
      image: "gastronomia",
      thumb: "tt-02",
      caption: "",
      href: "https://www.tiktok.com/@ruteando.sin.destino/video/7481492118880455991",
    },
    {
      brand: "Navegación Dique Potrerillos | @abordodelplata",
      type: "Video",
      platform: "tiktok",
      image: "experiencias",
      thumb: "tt-03",
      caption: "",
      href: "https://www.tiktok.com/@ruteando.sin.destino/video/7475862838368636215",
    },
    {
      brand: "Turismo | Isla del Campeche",
      type: "Video",
      platform: "tiktok",
      image: "destinos",
      thumb: "tt-04",
      caption: "",
      href: "https://www.tiktok.com/@ruteando.sin.destino/video/7434215683707260216",
    },
    {
      brand: "Barco Pirata en Florianópolis | @barcopirataflorianopolis",
      type: "Video",
      platform: "tiktok",
      image: "experiencias",
      thumb: "tt-05",
      caption: "",
      href: "https://www.tiktok.com/@ruteando.sin.destino/video/7433895876021603589",
    },
    {
      brand: "Viaje hacia Brasil | @ega_uruguay",
      type: "Video",
      platform: "tiktok",
      image: "destinos",
      thumb: "tt-06",
      caption: "",
      href: "https://www.tiktok.com/@ruteando.sin.destino/video/7433585424506948869",
    },
  ],
};
